import { HostMessageType } from '../../interfaces/host-message-types';
import { sendMessageToHost } from '../base/models/base-message';
import { MessageHandler } from '../base/interfaces/message.interface';

export const RequestLogoutMessage: MessageHandler<undefined> = {
  send(payload = undefined, targetOrigin = '*'): void {
    sendMessageToHost(HostMessageType.RequestLogout, payload, targetOrigin);
  },

  validatePayload(payload: unknown): payload is undefined {
    return payload === undefined;
  },
};
